import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M24 46.5c12.426 0 22.5-10.074 22.5-22.5S36.426 1.5 24 1.5 1.5 11.574 1.5 24 11.574 46.5 24 46.5m0 1.5c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m31.54 31.317.623-.623-1.884-1.884v-2.771h-.885v3.132zm-1.688 2.327c-1.304 0-2.41-.45-3.317-1.349-.908-.9-1.362-2-1.362-3.305 0-1.303.454-2.407 1.362-3.31.907-.902 2.013-1.353 3.317-1.353 1.293 0 2.39.454 3.29 1.361.899.908 1.348 2.009 1.348 3.303 0 1.293-.45 2.392-1.349 3.297-.9.904-1.995 1.356-3.289 1.356M16 30v-7.846.402V18zm0-9.596h16V18H16zM23.421 31.5H14.5v-15h19v6.806a6.896 6.896 0 0 0-1.773-.85 6.632 6.632 0 0 0-2.01-.302c-.764 0-1.49.128-2.177.384a6.34 6.34 0 0 0-1.848 1.058H16V30h6.994c.044.267.1.523.168.77s.154.49.26.73Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }